var _circle, _path, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgInvite = function SvgInvite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 18,
    r: 18,
    fill: "url(#invite_svg__paint0_linear)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 10H11a3 3 0 00-3 3v10a3 3 0 003 3h14a3 3 0 003-3V13a3 3 0 00-3-3zm-.67 2L18 16.75 11.67 12h12.66zM25 24H11a1 1 0 01-1-1v-9.75l7.4 5.55a1 1 0 001.2 0l7.4-5.55V23a1 1 0 01-1 1z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "invite_svg__paint0_linear",
    x1: 5,
    y1: 31.5,
    x2: 29,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A80FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2ECC71"
  })))));
};

export default SvgInvite;